export enum PaypalScriptStatus {
    init = 'init',
    loading = 'loading',
    loaded = 'loaded',
    failed = 'failed',
}

export interface PaypalNamespace {
    isMakingPaypalPayment: boolean;
    scriptStatus: PaypalScriptStatus;
}

export interface WithPaypalNamespace {
    paypal: PaypalNamespace;
}
